interface NameFields {
	firstName?: string | null;
	lastName?: string | null;
	email?: string | null;
}

export const formatDisplayName = (person: NameFields): string => {
	if (person.firstName || person.lastName) {
		return [person.firstName, person.lastName].filter(Boolean).join(" ");
	}
	return person.email ?? "";
};